import { Component, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { CardComponent } from '@app/ui-components/card/card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-section-f',
  imports: [TranslatePipe, CardComponent],
  templateUrl: './project-details-section-f.component.html',
  styleUrl: './project-details-section-f.component.scss',
})
export class ProjectDetailsSectionFComponent {
  projectDetails = input.required<ProjectPublicResponse>();
  protected translationKey = 'projectDetails.sectionF.';
}
